module.exports = __webpack_public_path__ + "static/media/bg-intro-top.47159b4f.png";